<template>
  <div
    class="column is-12">
    <div class="field">
      <div>
        <div
          class="field"
          :class="hasAddons ? 'has-addons' : ''">
          <p
            v-if="hasAddons"
            class="control">
            <a class="button is-square is-static is-border">
              <span class="icon"><i class="fas fa-map-marker-alt" /></span>
            </a>
          </p>
          <div
            class="control is-expanded">
            <input
              id="search_input"
              ref="search_input"
              :class="{ isValid: addressResume }"
              type="text"
              name="adress-input"
              class="input"
              :placeholder="addressResume ? '' : 'Adresse *'"
              :value="addressResume">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import uuidv4 from 'uuid/v4'
  import { isNil, debounce } from 'lodash'
  // import places from 'places.js'

  export default {
    name: 'AddressInput',
    props: {
      source: {
        type: Object,
        required: false
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        addressInputId: null,
        editAddress: false,
        line1: null,
        zip_code: null,
        city: null
      }
    },
    computed: {
      addressResume () {
        if (this.line1 && this.zip_code && this.city) {
          return `${this.line1}, ${this.city}, ${this.country || ''}`
        }
        return null
      }
    },
    watch: {
      source (v) {
        if (v) this.initAddressFromSource()
      }
    },
    mounted () {
      // eslint-disable-next-line no-undef
      const autocomplete = new google.maps.places.Autocomplete(
        this.$refs['search_input'],
        // eslint-disable-next-line no-undef
        { bounds: new google.maps.LatLngBounds(new google.maps.LatLng(43.602164, 1.444688)) },
        { types: ['geocode'] })
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()
        if (place.address_components) {
          console.log(place.address_components)
          const route = this.checkIfExist(place.address_components, 'route')
          const neighborhood = this.checkIfExist(place.address_components, 'neighborhood')
          const streetNumber = this.checkIfExist(place.address_components, 'street_number') || ''
          if (streetNumber && route) this.line1 = streetNumber + ' ' + route
          else if (route) this.line1 = route
          else if (neighborhood) this.line1 = neighborhood
          else this.line1 = null
          this.zip_code = this.checkIfExist(place.address_components, 'postal_code')
          this.city = this.checkIfExist(place.address_components, 'locality')
          this.country = this.checkIfExist(place.address_components, 'country')
          this.latitude = place.geometry.location.lat()
          this.longitude = place.geometry.location.lng()
        }
        this.update()
      })
    },
    created () {
      this.addressInputId = `address-input-${uuidv4()}`
      if (!isNil(this.source) && this.source.line1 && this.source.zip_code && this.source.city) {
        this.line1 = this.source.line1
        this.zip_code = this.source.zip_code
        this.city = this.source.city
      } else {
        this.editAddress = true
      }
    },
    methods: {
      checkIfExist (address, key) {
        if (address.find(x => x.types.includes(key))) return address.find(x => x.types.includes(key)).long_name
        else return null
      },
      update: debounce(function () {
        if (!this.line1 && !this.city && !this.zip_code && !this.country && !this.latitude && !this.longitude) {
          this.$emit('update', null)
        } else {
          this.$emit('update', {
            line1: this.line1,
            city: this.city,
            zip_code: this.zip_code,
            country: this.country,
            latitude: this.latitude,
            longitude: this.longitude
          })
        }
      }, 500),
      initAddressFromSource () {
        this.line1 = this.source.line1
        this.zip_code = this.source.zip_code
        this.city = this.source.city
        this.country = this.source.country
      }
    }
  }
</script>

<style scoped>
#search_input {
  width: 100%;
  border-bottom: 1px solid rgba(0,0,0,.42);
  color: rgba(0,0,0,.62);
  padding-bottom: 4px;
  margin-bottom: 20px;
}
.isValid {
  border-color: #8bc34a !important;
}
</style>
